import { theme } from 'shared/styles/theme';

import styled from '@emotion/styled';

export interface AvatarBaseProps {
  size?: number;
  entityName?: string;
  src?: string;
  alt?: string;
  rounded?: boolean;
  background?: string;
  className?: string;
  style?: React.CSSProperties;
  $fill?: boolean;
  isRightBorder?: boolean;
}

export const AvatarBase = styled.div<AvatarBaseProps>`
  min-width: ${({ size }) => `${size}px`};
  min-height: ${({ size }) => `${size}px`};
  border-radius: ${({ rounded }) => `${rounded ? '50%' : theme.borderRadius}`};
  line-height: 1;
  vertical-align: middle;
  overflow: hidden;
  user-select: none;
  background-color: ${({ background }) => background};
  background-image: ${({ src }) => `url(${src})`};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  background-size: cover;
  ${({ isRightBorder }) =>
    !isRightBorder
      ? 'border: 2px solid black;'
      : 'border-right: 2px solid black; border-top: 0; border-bottom: 0; border-left: 0;'}

  ${(props) => props.$fill && 'width: 100%; height: 100%;'}
`;
